import "./index.scss";

import { Box } from "@mui/material";
import { APP_LOGIN_URL } from "configs/env";
import { authActions } from "modules/auth";
import { useEffect } from "react";
import { useAppDispatch } from "redux/hooks";

const PageUnauthorized = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(authActions.logoutDone());
    dispatch(authActions.setLoggingOutFlag(false));
    window.location.href = APP_LOGIN_URL;
  }, []);

  return (
    <Box display="flex" flex={1} height="100vh" justifyContent="center" alignItems="center">
      <img
        alt="Unauthorized"
        src={require("assets/images/ui/error-401.webp")}
        // width={"100%"}
        // height={"100%"}
      />
    </Box>
  );
};

export default PageUnauthorized;
